<template>
  <div class="yhgl">
    <div class="thrkBody">
      <div class="bodyHeader">
        <div class="topFormStyle">
          <el-form
            ref="search"
            label-width="90px"
            :model="searchForm"
            label-position="left"
            style="width: 90%; margin: 0 auto"
          >
            <el-row>
              <el-col :span="10">
                <el-form-item label="名称:" prop="name" style="width: 100%">
                  <el-input
                    v-model="searchForm.name"
                    clearable
                    style="min-width: 120px;"
                    placeholder="请输入名称"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="rightbutton">
          <!-- <el-button
            icon="el-icon-refresh-left"
            style="width: 90px; height: 39px"
            round
            size="small"
            @click="reset"
            >重置</el-button
          > -->

          <!-- <el-button
            icon="el-icon-search"
            style="width: 90px; height: 39px"
            round
            size="small"
            @click="searchHandle"
            >搜索</el-button
          > -->
          <el-button
            type="primary"
            icon="el-icon-s-fold"
            round
            size="small"
            @click="zhankaiORzhedie()"
          >展开折叠</el-button>
          <el-button
            type="primary"
            icon="el-icon-plus"
            round
            size="small"
            @click="formOfAdd"
          >新增</el-button>
          <el-button
            round
            type="warning"
            style="width: 140px; height: 39px"
            size="small"
            @click="meanreload"
          >刷新菜单缓存</el-button>
        </div>
      </div>
      <div class="mainBody">
        <div class="bodyLeft">
          <!-- 左侧分级 -->
          <el-tree
            ref="resourceTree"
            :data="dataSearchTree"
            node-key="resourceId"
            :expand-on-click-node="false"
            :props="defaultProps"
            @node-click="changeRecourse"
          />
        </div>
        <div class="thrkRight">
          <div class="bodyTable">
            <div class="thrkLeft2">
              <el-table
                ref="table"
                :data="tableSearchData"
                border
                row-key="resourceId"
                :header-cell-style="{ background: '#F3F5FA' }"
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                style="width: 100%"
              >
                <el-table-column
                  show-overflow-tooltip
                  label="名称"
                  min-width="200px"
                  prop="title"
                  align="left"
                />
                <el-table-column
                  label="排序"
                  prop="sort"
                  align="center"
                />
                <el-table-column
                  label="路由/URI"
                  prop="path"
                  align="left"
                  min-width="200px"
                >
                  <template slot-scope="scope">{{
                    scope.row.path || scope.row.url
                  }}</template>
                </el-table-column>
                <el-table-column label="可见" prop="hidden" align="center">
                  <template slot-scope="scope">{{
                    scope.row.resourceFlag !== 3
                      ? scope.row.hidden
                        ? "否"
                        : "是"
                      : "/"
                  }}</template>
                </el-table-column>
                <el-table-column label="类型" prop="resourceFlag" align="center">
                  <template slot-scope="scope">{{
                    types[scope.row.resourceFlag]
                  }}</template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  fixed="right"
                  align="center"
                  width="180px"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      size="mini"
                      round
                      style="
                      color: #409eff;
                      border-color: #409eff;
                      border-radius: 30px;
                      background-color: rgb(230, 242, 252);
                    "
                      @click="formOfEdit(scope.row)"
                    >编辑</el-button>
                    <el-button
                      type="primary"
                      size="mini"
                      round
                      style="
                      color: #409eff;
                      border-color: #409eff;
                      border-radius: 30px;
                      background-color: rgb(230, 242, 252);
                    "
                      @click="deleteHandle(scope.row)"
                    >删除</el-button>
                  </template>
                </el-table-column>
              </el-table>

            <!-- <el-pagination
              style="float: right"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pageSize"
              layout=" prev, pager, next,total, jumper"
              :total="total"
            >
            </el-pagination> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-for="(item, index) in showDetail">
      <component
        :is="item.curCom"
        v-show="item.curCom === currentView"
        :key="index"
        :ref="item.cuRef"
        :tree="dataTree"
        @refresh="loadData"
      />
    </template>
  </div>
</template>
<script>
import { getResourceList, deleteResource } from '@/assets/js/resource.js'
import addMenu from '@/components/cdManage/addMenu'
import editMenu from '@/components/cdManage/editMenu'
import { meanreload } from '@/assets/js/xtgl.js'
export default {
  name: 'User',
  components: {
    addMenu,
    editMenu
  },
  data() {
    return {
      cuRefOfCom: '', // 当前的ref
      dataTree: [],
      defaultProps: {
        children: 'items',
        label: 'title'
      },
      isShowHome: true,
      currentView: '',
      showDetail: [
        {
          isShow: false,
          index: 0,
          curCom: 'addMenu',
          type: 'add',
          cuRef: 'addMenuRef'
        },
        {
          isShow: false,
          index: 1,
          curCom: 'editMenu',
          type: 'edit',
          cuRef: 'editMenuRef'
        }
      ],
      types: {
        0: '超级管理员的路由',
        1: '菜单路由',
        2: '路由接口', // 注意他必须是个子路由
        3: '接口级限制'
      },
      openORfold: true,
      pupopShow: false,
      pageSize: 10,
      currentPage: 1,
      total: 4,
      cellStyle: {
        color: '#2774e0',
        fontSize: '16px',
        textDecoration: 'underline'
      },
      searchForm: {
        name: ''
      },
      tableData: []
    }
  },
  computed: {
    tableSearchData() {
      if (this.searchForm.name) {
        console.log('xxxxxsearch', this.searchForm.name)
        const data = this.handleTreeData(this.tableData, this.searchForm.name)
        return data
      }
      return this.tableData
    },
    dataSearchTree() {
      if (this.searchForm.name) {
        let data = this.handleTreeData(this.dataTree, this.searchForm.name)
        data = data.map(d => {
          if (d.children) {
            d.items = d.children.map(j => {
              j.label = j.areaName
              return j
            })
          }
          d.label = d.deptName
          return d
        })
        if (data && data.length > 0) {
          this.changeRecourse(data[0], -1)
        }
        return data
      }
      return this.dataTree
    }
  },
  created() { },
  mounted() {
    this.loadData()
  },
  beforeDestroy() { },
  methods: {
    handleTreeData(treeData, searchValue) {
      if (!treeData || treeData.length === 0) {
        return []
      }
      const array = []
      for (let i = 0; i < treeData.length; i += 1) {
        let match = false
        for (const pro in treeData[i]) {
          if (typeof treeData[i][pro] === 'string') {
            match |= treeData[i][pro].includes(searchValue)
            if (match) break
          }
        }
        if (
          this.handleTreeData(treeData[i].children, searchValue).length > 0 ||
          match
        ) {
          array.push({
            ...treeData[i],
            children: this.handleTreeData(treeData[i].children, searchValue)
          })
        }
      }
      return array
    },
    // 刷新菜单缓存
    meanreload() {
      meanreload().then((res) => {
        if (res.status === 200 && res.data.code === '000000') {
          this.$message({
            type: 'success',
            message: '刷新成功'
          })
        }
      })
    },
    buildFilterTree(arr, fun) {
      const data = arr.filter(fun).map((item) => {
        item = Object.assign({}, item)
        if (item.children) {
          // 递归循环
          item.items = this.buildFilterTree(item.children, fun)
        }
        return item
      }).sort((a, b) => {
        return (a.sort || 0) - (b.sort || 0)
      })
      return data
    },
    filterTree(value, data) {
      if (!value) return true
      return data.title.indexOf(value) !== -1
    },
    changeRecourse(data, depth = 1) {
      // 选择机构
      console.log(data)
      this.openORfold = depth === -1
      this.tableData = [data]
      this.$nextTick(() => {
        // 展开下一级
        this.toggleRowExpansionAll(this.tableData, depth)
      })
    },
    searchHandle() {
      this.loadData()
    },
    reset() {
      this.$refs['search'].resetFields()
    },
    deleteHandle(row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteResource(row.resourceId).then(res => {
          console.log('deleteResource', res)
          if (res.status === 200 && res.data.code === '000000') {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.loadData()
          }
        })
      })
    },
    loadData() {
      getResourceList({
        param: this.searchForm
      }).then(res => {
        console.log('getResourceList', res)
        if (res.status === 200 && res.data.code === '000000') {
          // 成功
          // this.dataTree = res.data.data
          this.dataTree = this.buildFilterTree(res.data.data, (d) => {
            return d.resourceFlag <= 1
          })
          if (this.dataTree && this.dataTree.length > 0) {
            this.tableData = [this.dataTree[0]]
            this.$nextTick(() => {
              // this.$refs.resourceTree.filter('');
              this.toggleRowExpansionAll(this.tableData, -1)
            })
          }
        }
      })
    },
    // 编辑
    formOfEdit(row) {
      this.showDetail.forEach((item) => {
        if (item.type == 'edit') {
          this.currentView = item.curCom
          this.cuRefOfCom = item.cuRef
          return
        }
      })
      this.$refs[this.cuRefOfCom][0].show(row)
    },
    // 新增
    formOfAdd() {
      this.showDetail.forEach((item) => {
        if (item.type == 'add') {
          this.currentView = item.curCom
          this.cuRefOfCom = item.cuRef
          return
        }
      })
      this.$refs[this.cuRefOfCom][0].show()
    },
    handleNodeClick(data) { },
    handleSizeChange(val) { },
    handleCurrentChange(val) { },
    openOrCloseTree(data) {
      if (data) {

      }
    },
    toggleRowExpansionAll(data, depth = -1, status = true) {
      console.log('depth', depth)
      if (depth === 0) {
        return
      }
      if (depth !== -1) {
        depth--
      }
      data.forEach((item) => {
        this.$refs.table.toggleRowExpansion(item, status)
        if (depth > 0 || depth === -1) {
          if (item.children !== undefined && item.children !== null) {
            this.toggleRowExpansionAll(item.children, depth, status)
          }
        }
      })
    },
    zhankaiORzhedie() {
      this.openORfold = !this.openORfold
      this.toggleRowExpansionAll(this.tableData, -1, this.openORfold)
      // this.tableData.forEach((e, i) => {
      //   this.$refs.table.toggleRowExpansion(e);
      // });
    }
  }
}
</script>
<style scoped lang="less">
.yhgl {
  .thrkBody {
    margin: 0 auto;
    .bodyHeader {
      width: 95%;
      background-color: #fff;
      margin: 0 auto;
      margin-bottom: 11px;
      margin-top: 30px;
      display: flex;
      align-items: center;
      padding: 30px 0 0 0;
      border-radius: 5px;
      padding-right: 75px;
      .topFormStyle {
        width: calc(100% - 390px);
        height: 100%;
      }
      .rightbutton {
        text-align: right;
        width: 100%;
        height: 62px;
      }
      // .el-form-item {
      //   margin-right: 30px;
      //  // width: 22%;
      //   &:nth-child(4) {
      //     margin-right: 0px;
      //   }
      //   &:nth-child(5) {
      //     width: 50%;
      //     .el-date-editor {
      //       width: 40%;
      //     }
      //   }
      //   .el-form-item__content {
      //     //display: flex;
      //   }
      // }

      .el-button--primary {
        color: #fff;
        background: #4170ff;
        border-color: #4170ff;
        width: 90px;
        height: 39px;
      }
    }
    .mainBody {
      width: 95%;
      display: flex;
      flex-direction: row;
      margin: 0 auto;
      .bodyLeft {
        width: 250px;
        background-color: #fff;
        height: 100%;
        padding: 40px 20px;
      }
    }
    .thrkRight {
      margin-left: 10px;
      width: calc(95% - 200px);
      background-color: #fff;
      padding-top: 40px;
      padding-bottom: 57px;
      .bodyTable {
        width: 90%;
        margin: 0 auto;
        display: flex;
        .thrkLeft1 {
          width: 200px;
          margin-right: 15px;
        }
        .thrkLeft2 {
          width: 100%;
          .addmessheader {
            background: #f4f4f4;
            .addmess {
              margin: 12px 0 12px 8px;
            }
          }
          .el-button--primary {
            color: #fff;
            background: #4170ff;
            border-radius: 3px;
            border-color: #4170ff;
          }
        }
      }
      .el-pagination__total {
        margin-left: 8px;
      }
      .el-pagination {
        padding: 10px 0;

        border: 1px solid #ebeef5;
        border-top: 0;
      }
      .el-pager {
        .number {
          background: #4170ff;
          border-color: #4170ff;
        }
      }
    }
  }
}
.el-select {
  width: 100%;
}

/deep/.el-dialog__header {
  .header-title {
    text-align: left;
  }
}
/deep/.el-dialog__body {
  padding: 0;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
</style>
